const leaderSeminar = () => import('../views/leader-seminar/notice')

export default [
  {
    path: '/leader-seminar',
    name: 'leader-seminar',
    component: leaderSeminar
  },
]